import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MotifDialog } from "./MotifDialog";

export const EtapeMenu = ({ etapes, actuelle, onChoisir, testId = "stage-menu", className = "", label = "Changer d'étape" }) => {
  const [motifPour, setMotifPour] = useState(null);
  const choisir = (e) => (e.sortie === "perdu" ? setMotifPour(e) : onChoisir(e.code));
  const normales = etapes.filter((e) => e.sortie !== "perdu");
  const perdues = etapes.filter((e) => e.sortie === "perdu");
  const Item = ({ e }) => (
    <DropdownMenuItem disabled={!e.autorisee || e.code === actuelle} onClick={() => choisir(e)} className="min-h-[44px] rounded-xl cursor-pointer gap-2" data-testid={`${testId}-option-${e.code}`}>
      <span className="w-2.5 h-2.5 at-pill shrink-0" style={{ background: e.temperature || "var(--muted)" }} />{e.nom}
    </DropdownMenuItem>
  );
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" className={`at-btn at-btn-ghost ${className}`} data-testid={testId}>{label}<ChevronDown size={16} /></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="at-popover w-64 p-2">
          {normales.map((e) => <Item key={e.code} e={e} />)}
          {perdues.length > 0 && <DropdownMenuSeparator />}
          {perdues.map((e) => <Item key={e.code} e={e} />)}
        </DropdownMenuContent>
      </DropdownMenu>
      <MotifDialog etape={motifPour} onFermer={() => setMotifPour(null)} onValider={(code, motif) => { setMotifPour(null); onChoisir(code, motif); }} />
    </>
  );
};
